import {
  COUNTRY_CODE,
  PhoneCountryCodeMap,
  isValidEmail,
  validatePhoneWithCountrySelection,
} from "@kivunova/kivufrontendcommon";
import { PaymentMethod } from "../Payments/enums/paymentEnums";

export type PaymentFieldErrors = {
  general?: string;
  phone?: string;
  email?: string;
  cardNumber?: string;
  cardExpiry?: string;
  cardCvc?: string;
  cardName?: string;
};

export type PaymentFormValues = {
  selectedMethod: PaymentMethod;
  mtnPhoneCountryCode: string;
  mtnPhoneNumber: string;
  airtelPhoneCountryCode: string;
  airtelPhoneNumber: string;
  cardEmail: string;
  cardNumber: string;
  cardExpiry: string;
  cardCVC: string;
  cardName: string;
};

export type PaymentValidationMessages = {
  phoneRequired: string;
  phoneInvalid: string;
  emailInvalid: string;
  cardNumberInvalid: string;
  cardExpiryInvalid: string;
  cardCvcInvalid: string;
  cardNameRequired: string;
};

const CARD_EXPIRY_REGEX = /^(0[1-9]|1[0-2])\s*\/\s*\d{2}$/;

const findCountryKeyByDialCode = (dialCode: string): string | undefined =>
  (Object.keys(PhoneCountryCodeMap) as COUNTRY_CODE[]).find(
    (key) => PhoneCountryCodeMap[key].code === dialCode,
  );

const validateMobileMoneyPhone = (
  phoneNumber: string,
  dialCode: string,
  errors: PaymentFieldErrors,
  messages: PaymentValidationMessages,
): void => {
  const trimmed = phoneNumber.trim();
  if (!trimmed) {
    errors.phone = messages.phoneRequired;
    return;
  }
  const countryKey = findCountryKeyByDialCode(dialCode);
  if (!countryKey || !validatePhoneWithCountrySelection(trimmed, countryKey)) {
    errors.phone = messages.phoneInvalid;
  }
};

export const validatePaymentForm = (
  values: PaymentFormValues,
  messages: PaymentValidationMessages,
): PaymentFieldErrors | null => {
  const errors: PaymentFieldErrors = {};

  switch (values.selectedMethod) {
    case PaymentMethod.MTN_MOMO:
      validateMobileMoneyPhone(
        values.mtnPhoneNumber,
        values.mtnPhoneCountryCode,
        errors,
        messages,
      );
      break;
    case PaymentMethod.AIRTEL_MONEY:
      validateMobileMoneyPhone(
        values.airtelPhoneNumber,
        values.airtelPhoneCountryCode,
        errors,
        messages,
      );
      break;
    case PaymentMethod.CREDIT_DEBIT: {
      if (!values.cardEmail.trim() || !isValidEmail(values.cardEmail.trim())) {
        errors.email = messages.emailInvalid;
      }
      const digits = values.cardNumber.replace(/\s/g, "");
      if (!/^\d{13,19}$/.test(digits)) {
        errors.cardNumber = messages.cardNumberInvalid;
      }
      if (!CARD_EXPIRY_REGEX.test(values.cardExpiry.trim())) {
        errors.cardExpiry = messages.cardExpiryInvalid;
      }
      if (!/^\d{3,4}$/.test(values.cardCVC.trim())) {
        errors.cardCvc = messages.cardCvcInvalid;
      }
      if (!values.cardName.trim()) {
        errors.cardName = messages.cardNameRequired;
      }
      break;
    }
    case PaymentMethod.PAYPAL:
      break;
    default:
      break;
  }

  return Object.keys(errors).length > 0 ? errors : null;
};
